import {
  ValidateOTPRequest,
  ValidateOTPResponse,
} from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { useMutation } from '@tanstack/react-query';

import axios from '../../axios';

const validateCode = async (requestBody: ValidateOTPRequest) => {
  const { data } = await axios.post<ValidateOTPResponse>(
    `${import.meta.env.VITE_REGISTRATIONS_API_URL}/v1/otp/validate`,
    requestBody
  );

  return data;
};

export const useValidateCodeMutation = () =>
  useMutation({
    mutationFn: (requestBody: ValidateOTPRequest) => validateCode(requestBody),
  });
